  <!-- Hero Start -->
  <section class="bg-half d-table w-100" id="home">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6">
                <div class="card border-0 shadow rounded p-4 sticky-bar" *ngIf="project">
                       <div class="card border-0 work-container work-primary work-grid position-relative d-block overflow-hidden rounded">
                                            <div class="card-body p-0" *ngIf="project.Images && project.Images.length > 0">
                                                <a href="javascript:void(0);" (click)="openGallery('0')">
                                                    <img src="{{project.Images[0].ImageUrl}}" class="img-fluid" alt="work-image">
                                                </a>
                                                <div class="content p-3">
                                                    <h5 class="mb-0"><a routerLink="/portfolio-detail-one" class="text-dark title">{{currentLang === 'ar' ? project.TitleAr : project.TitleEn }}</a></h5>
                                                </div>
                                            </div>
                                        </div>
                   
                    <!-- <img *ngFor="let img of project.Images" src="{{img.ImageUrl}}" class="avatar avatar-medium p-4 bg-white shadow-md rounded-pill" alt=""> -->
                    
                    <div class="mt-4">
                        <h4 class="title mb-3">{{currentLang === 'ar' ? project.TitleAr : project.TitleEn }} </h4>
                     
                    </div>
                </div>
            </div><!--end col-->

            <div class="col-lg-8">
                <div class="sidebar border-0">
                    <h5 class="mb-0">{{'Description'|translate}}</h5>

                    <ul class="list-unstyled mb-0 mt-4">                                
                     


                        <li class="list-inline-item px-3 py-2 shadow rounded text-start">
                            <div class="d-flex widget align-items-center">
                                <i-feather name="clock" class="fea icon-ex-md me-3"></i-feather>
                                <div class="flex-1">
                                    <h6 class="widget-title mb-0">{{'Date posted:'| translate}}</h6>
                                    <small class="text-primary mb-0 mb-0"> {{project.ProjectDate | date : 'dd/MM/yyyy'}} </small>
                                </div>
                            </div>
                        </li>

                        


                        <!-- <li class="list-inline-item px-3 py-2 shadow rounded text-start">
                            <div class="d-flex widget align-items-center">
                                <i-feather name="book" class="fea icon-ex-md me-3"></i-feather>
                                <div class="flex-1">
                                    <h6 class="widget-title mb-0">  {{'Project Duration' | translate}} </h6>
                                    <small class="text-primary mb-0"> {{project.ProjectDuration}} </small>
                                </div>
                            </div>
                        </li> -->

                   
                    </ul>
                </div>

                  <div class="mt-4">
                    <h5 class="mb-0">{{currentLang === 'ar' ? project.SubTitleAr : project.SubTitleEn }}</h5>
                    <p class="text-muted">{{currentLang === 'ar' ? project.Pragraph1Ar : project.Pragraph1En }}     </p>
                    <p class="text-muted">{{currentLang === 'ar' ? project.Pragraph2Ar : project.Pragraph2En }}     </p>
                    <p class="text-muted">{{currentLang === 'ar' ? project.Pragraph3Ar : project.Pragraph3En }}     </p>
                    
                 
                </div>
            </div><!--end col-->
        </div><!--end row-->
    </div><!--end container-->
</section><!--end section-->
<!-- Job Detail End -->

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->
